<template>
  <div v-show="showStoreConfirmation && ready" :style="{top: `${position.top}px`,left: `${position.left}px`}" class="store-confirm-window">
    <div>
      <div :style="arrowPos" class="arrow"></div>
      <div class="store-locator-window-root">
        <div class="heading"> </div>

        <div class="content">
          <div class="item-name">{{ currentStoreObj.storeName }}</div>
          <span>{{ toTitleCase(currentStoreObj.address) }}, {{ toTitleCase(currentStoreObj.city) }}, {{ currentStoreObj.province }}</span>
          <div>604.448.4802</div>
          <div>Open . Closes 9pm</div>
        </div>
        <div class="buttons">
          <button class="flyer-tour-btn skip-button" @click="closeStoreSelection()">
            {{ content.storeLocator.confirmStore }}
          </button>

          <button class="flyer-tour-btn next" @click="changeStore()">
           {{ content.storeLocator.changeStore }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {toTitleCase} from "@/utils";

export default {
  data() {
    return {
      position: {
        top:0,
        left:0
      },
      arrowPos: null
    }
  },
  mounted() {
    setTimeout(()=>{
      this.setPosition();
    },500)
  },
  computed: {
    ...mapState('storeLocator',['showStoreConfirmation']),
    ...mapState(['currentStoreObj']),
    ...mapGetters('screen',['displayMode']),
    ...mapGetters(['content']),

    ready(){
      return(this.position.top !== 0 && this.position !== 0)
    }
  },
  methods: {
    ...mapActions('storeLocator',['toggleStoreConfirmation','toggleStoreSelection']),
    toTitleCase,
    closeStoreSelection(){
      this.toggleStoreConfirmation(false);
    },
    changeStore(){
      this.toggleStoreConfirmation(false)
      this.toggleStoreSelection(true)
    },
    setPosition() {
      const target = document.querySelector('.storeLocator')
      if(target) {
        const rect = target.getBoundingClientRect();
        this.position.top = rect.bottom + window.scrollY + 10;
        if(this.displayMode==='mobile' || this.displayMode==='tablet') this.position.left = rect.left + window.scrollX - 145
        else this.position.left = rect.left + window.scrollX
      }
    },
  },
  watch:{
      displayMode(){
        this.setPosition()
    }
  }
}
</script>

<style lang="scss" scoped>
.store-confirm-window{
  position: absolute;
  z-index: 1000;
  font-size: 14px;
  width: 325px;
  transition: All 300ms;

  * {
    transition: All 300ms;
  }

  filter: drop-shadow(2px 2px 3px #000);

  .store-locator-window-root {
    border-radius: 4px;
    overflow: hidden;
    background-color: #fff;

    .heading {
      display: flex;
      justify-content: space-between;
      background-color: var(--secondary-color);
      color: var(--primary-text-color);
      border-bottom: 1px solid #eee;
      margin: 0;
      padding: 5px 10px;
    }

    .content {
      padding: 1em;
      display: flex;
      flex-direction: column;
      gap: 0.5em;
      line-height:20px;

      .item-name {
        font-weight: bold;
        color: var(--secondary-color);
      }
    }
  }

  .arrow {
    position: absolute;
    transform: translate(-50%, -50%) rotateZ(45deg);
    width: 12px;
    height: 12px;
    background-color: var(--secondary-color);
    top: 0;
    left: 50%;
    z-index: -1;
  }

  .buttons {
    padding: 0 0.9em 1em;
    display: flex;
    gap: 0.5em;
    justify-content: space-between;
    align-items: center;
    button{
      background: var(--secondary-color);
      color: #fff;
    }

  }
}
</style>